import { useEffect, useState } from "react";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import api from "@/lib/api";
import { fmtDate } from "@/lib/credits";
import { Input } from "@/components/ui/input";
import { Search, Loader2, Droplets } from "lucide-react";

export default function ActivationHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState("");

  const load = async (query) => {
    setLoading(true);
    try {
      const { data } = await api.get("/activations", { params: query ? { q: query } : {} });
      setRows(data);
    } catch (e) {} finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);
  useEffect(() => { const t = setTimeout(() => load(q.trim() || undefined), 300); return () => clearTimeout(t); }, [q]);

  return (
    <DashboardLayout title="Activation History">
      <div className="mb-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-[#E30613]">Bottle Activations</p>
        <h2 className="mt-2 font-display text-2xl font-semibold tracking-tight text-white">Your activation history</h2>
        <p className="mt-1 text-sm text-neutral-500">Every SGBINOXE bottle you've activated, newest first.</p>
      </div>
      <div className="relative mb-5 max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search activation code…" className="h-11 rounded-lg border-white/[0.1] bg-[#0A0A0A] pl-10 text-white placeholder:text-neutral-600 focus-visible:border-[#E30613] focus-visible:ring-1 focus-visible:ring-[#E30613]" data-testid="activation-search" />
      </div>
      <div className="overflow-hidden rounded-2xl border border-white/[0.06] bg-[#141414]" data-testid="activation-history-table">
        {loading ? (
          <div className="flex items-center justify-center py-20 text-neutral-500"><Loader2 className="h-5 w-5 animate-spin" /></div>
        ) : rows.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-center">
            <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-white/[0.04] text-neutral-500"><Droplets className="h-6 w-6" /></span>
            <p className="mt-4 text-sm text-neutral-400">No bottle activations yet</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b border-white/[0.06] text-xs uppercase tracking-wider text-neutral-500">
                  <th className="px-6 py-4 font-medium">Activation Date</th>
                  <th className="px-6 py-4 font-medium">Activation Code</th>
                  <th className="px-6 py-4 font-medium">Credits Added</th>
                  <th className="px-6 py-4 font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-white/[0.04] hover:bg-white/[0.03]">
                    <td className="px-6 py-4 text-sm text-neutral-300">{fmtDate(r.activation_date, true)}</td>
                    <td className="px-6 py-4 font-mono text-sm text-white">{r.masked_code}</td>
                    <td className="px-6 py-4 text-sm font-medium text-emerald-400">+{r.credits_added}</td>
                    <td className="px-6 py-4"><span className="inline-flex rounded-full border border-emerald-500/20 bg-emerald-500/10 px-2.5 py-0.5 text-xs font-medium capitalize text-emerald-400">{r.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
